/* eslint-disable import/prefer-default-export */
import { artistRepInviteTokenUrl } from '../urls';

export async function getArtistRepInviteToken(token) {
  const url = `${artistRepInviteTokenUrl}?token=${encodeURIComponent(token)}`;
  const response = await fetch(url, {
    method: 'GET',
  });
  return response;
}
